import { SavedList } from 'services/savedLists/types';
import { UserCustomerTypes } from 'services/user/types';

export enum SAVED_LIST_COLUMN {
  NAME = 'name',
  ACTIONS = 'actions',
  QUANTITY = 'quantity',
  CREATED_BY = 'createdBy',
  UPDATED_DATE = 'updated',
  LIST_TYPE = 'type',
  EQUIPMENT = 'Equipment'
}

export enum SORT_TYPE {
  ALPHANUMERIC = 'ALPHANUMERIC',
  NUMERIC = 'NUMERIC',
  DATE = 'DATE',
  CURRENCY = 'CURRENCY',
  EQUIPMENT = 'EQUIPMENT'
}

export enum SORT_DIRECTIONS {
  DESC = 'descending',
  ASC = 'ascending'
}

export interface SavedListColumnConfig {
  id: string;
  label?: string;
  behavior?: 'sortable' | 'filter';
  sortType?: SORT_TYPE;
  width: string;
  align?: 'center' | 'right';
  sortDirection?: SORT_DIRECTIONS;
}

export type SavedListTableSchema = SavedListColumnConfig[];

export type SavedListsTableHeaderProps = {
  isCspUser: boolean;
  savedListsTableSchema: SavedListTableSchema;
  customerType: UserCustomerTypes;
};

export type SavedListsTableBodyProps = {
  savedListsTableSchema: SavedListTableSchema;
  savedLists: SavedList[];
  customerType: string;
  showSkeletonLoader: boolean;
  savedListDetailFeatureFlag?: boolean;
  locale?: string;
};

export type SortDetails = {
  data: SavedList[];
  sortBy: string;
  sortType: SORT_TYPE;
  sortDirection: SORT_DIRECTIONS;
};
